<template>
  <vue-slider v-model="sliderValue"
              :min="minSanitized"
              :max="maxSanitized"
              :interval="5000"
              :tooltip="'none'"
              :disabled="disabled"
              @change="changeEvent"
              style="width:100%;"
  ></vue-slider>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  components:{VueSlider},
  name: "Slider",
  props:{
    value:{
      type:Number,
      default:20000
    },
    min:{
      type:Number,
      default:20000
    },
    max:{
      type:Number,
      default:1000000
    },
    disabled:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      sliderValue:20000,
      minSanitized:20000,
      maxSanitized:1000000,
    }
  },
  watch:{
    value(val){
      this.sliderValue=this.sanitizeSliderValue(val);
    },
    min(val){
      this.minSanitized=this.sanitizeSliderValue(val);
    },
    max(val){
      this.maxSanitized=this.sanitizeSliderValue(val);
    }

  },
  methods:{
    sanitizeSliderValue(val){
      return parseInt(String(val).replaceAll('.',''));
    },
    changeEvent(value){
      this.$emit('slider-change',value);
    },
    sanitizeSliderValues(){
      this.sliderValue=this.sanitizeSliderValue(this.value);
      this.maxSanitized=this.sanitizeSliderValue(this.max);
      this.minSanitized=this.sanitizeSliderValue(this.min);
    }
  },
  beforeUpdated() {
      this.sanitizeSliderValues();
  },
  mounted() {
    this.sanitizeSliderValues();
  }
}
</script>

